import {InputLabel, Option, Select} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';

const AssetMultiselectDropDown = (props) => {
  const {t} = useTranslation();
  const [selectedAsset, setSelectedAsset] = React.useState('');
  React.useEffect(() => {
    if (props.optionData.length == 1) {
      setSelectedAsset(props.optionData[0]);
      props.setSelectedAssetsList(props.optionData);
    } else {
      setSelectedAsset(props.value);
    }
  }, [props.optionData, props.value]);

  return (
    <div className="logBookAssetList">
      <InputLabel htmlFor="select-widget" id="select-label">
        {props.label}
        {props.required && <span className="requiredField">*</span>}
      </InputLabel>
      <Select
        id="AssetsList"
        name="AssetsList"
        value={selectedAsset || ''}
        defaultValue={selectedAsset || ''}
        className={'asset-list-dropdown'}
        required={props.required}
        multiple
        hasSelectAll
        onChange={props.onChangeHandler}
        placeholder={t('LOGBOOK_MODEL_NUMBER_PLACEHOLDER')}
      >
        {props.optionData.map((item, index) => (
          <Option key={'logbook-reason' + item} value={item}>
            {item}
          </Option>
        ))}
      </Select>
    </div>
  );
};
export default AssetMultiselectDropDown;
